import type { AccountSummary } from '../../types';

type Props = {
  accounts: AccountSummary[];
  onActivate: (accountId: string) => void;
};

const AccountSelector = ({ accounts, onActivate }: Props) => {
  const active = accounts.find((a) => a.isActive) ?? accounts[0];
  if (!active) return null;

  return (
    <div className="account-selector-bar">
      <label className="account-selector-label">
        <span className="account-selector-icon" aria-hidden="true">📱</span>
        <span className="sr-only">Actief WhatsApp-nummer</span>
        <select
          className="account-selector-select"
          value={active.id}
          onChange={(e) => onActivate(e.target.value)}
        >
          {accounts.map((account) => (
            <option key={account.id} value={account.id}>
              {account.label} — {account.status.state === 'ready' ? 'Verbonden' : 'Niet verbonden'}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};

export default AccountSelector;
